export const isLiteralObject = (variable) => (!!variable) && (variable.constructor === Object);

export const copy = (v) => JSON.parse(JSON.stringify(v));

// naive implementation
export const merge = (obj1, obj2) => ({
  ...copy(obj1),
  ...copy(obj2),
});

// naive implementation
export const equals = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

// TODO: method is incorrect. Not working for vuex objects.
// Should be Object.keys(currentState.sliderOptions).length === 0
export const isObjectEmpty = (obj) => Object.getOwnPropertyNames(obj).length === 0;

export const removeUndefinedValues = (obj) => Object.fromEntries(
  Object.entries(obj)
    .filter(([key, value]) => value !== undefined),
);

export const removeEmptyValues = (obj) => Object.fromEntries(
  Object.entries(obj)
    .filter(([key, value]) => value || value === 0),
);

export const getAttributeByPath = (object, path) => path.split('.').reduce(
  (accumulator, key) => accumulator && accumulator[key] ? accumulator[key] : undefined, object,
);

export const omit = (obj1, obj2) => Object.fromEntries(Object.entries(obj1).filter(([key, value]) => obj2[key] !== value));
